import React, {ReactNode} from 'react';
import {Title, Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from './styles.module.scss';
import {FormData} from '../DialogHeader';
import texts from '../../texts';
import {getMappedFields} from '../../utils/utils';
import {isRTL} from '../../../../Localization';

type Props = {
    suggestion: FormData;
    renderSectionContent: (records, sectionData) => ReactNode;
    suggestionSectionRef: React.RefObject<HTMLDivElement>;
};

export const SuggestionSection = (props: Props) => {
    const {suggestion, renderSectionContent, suggestionSectionRef} = props;
    const mappedFields = getMappedFields(suggestion);
    const isEmpty = mappedFields.length === 0;

    return (
        <div
            className={cx(styles.suggestionContainer, {
                [styles.rtl]: isRTL()
            })}
            ref={suggestionSectionRef}
        >
            <div className={styles.iconContainer}>
                <Icon
                    componentClasses={styles.suggestionIcon}
                    icon={PriorityIcon.bulb}
                    iconColor="white"
                />
            </div>
            <div className={styles.suggestionSection}>
                <div className={styles.sectionHeader}>
                    <button className={styles.toggleBtn} />
                    <Title
                        skin="h6"
                        textColor="secondary-400"
                        componentClasses={styles.sectionTitle}
                    >
                        {suggestion.formTitle}
                    </Title>
                </div>
                <div className={styles.sectionContent}>
                    {isEmpty ? (
                        <Text tag="div" skin="paragraph-2" textColor="secondary-400">
                            {texts.no_details_msg}
                        </Text>
                    ) : (
                        renderSectionContent(mappedFields, suggestion)
                    )}
                </div>
            </div>
        </div>
    );
};
